import React from 'react';
import { Link } from 'react-router-dom';
import { timeAgo } from '../utils/dateUtils';

function ActivityFeed({ activities }) {
  if (!activities || activities.length === 0) {
    return (
      <div className="activity-card">
        <div className="activity-card-header">
          <span className="activity-card-title">Recent Activity</span>
          <span className="activity-count-badge">0</span>
        </div>
        <div className="activity-empty">No recent activity recorded.</div>
      </div>
    );
  }

  return (
    <div className="activity-card">
      <div className="activity-card-header">
        <span className="activity-card-title">Recent Activity</span>
        <span className="activity-count-badge">{activities.length}</span>
      </div>
      <div className="activity-feed">
        {activities.map((item, idx) => (
          <Link
            key={item.id}
            to={`/bungalows/${item.bungalow_id}${item.stage_id ? `?stage=${item.stage_id}` : ''}`}
            className="activity-item activity-item--link"
          >
            <div className="activity-timeline">
              <div className="activity-dot"></div>
              {idx < activities.length - 1 && <div className="activity-line"></div>}
            </div>
            <div className="activity-body">
              <div className="activity-top-row">
                {item.project_name && (
                  <span className="activity-project-tag">{item.project_name}</span>
                )}
                <span className="activity-plot-badge">{item.bungalow_number}</span>
                <span className="activity-time">{timeAgo(item.created_at)}</span>
              </div>
              <p className="activity-action">{item.action}</p>
              {item.details && <p className="audit-log-details">{item.details}</p>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default ActivityFeed;
